export default {
  state: {
    touchPoints: [],
    microAnimationButtons: [],
    masks: []
  },
  mutations: {
    pushMasks(state, payload) {
      state.masks = payload;
    },
    pushTouchpoints(state, payload) {
      state.touchPoints = payload;
    },

    pushMicroAnimationBUttons(state, payload) {
      state.microAnimationButtons = payload;
    }
  },
  actions: {
    generateMasks({ commit, rootState }) {
      let tempArr = [];
      for (let animation of rootState.macroAnimations) {
        let tempObj = {
          ...animation.mask,
          ref: animation.ref
        };
        tempArr.push(tempObj);
      }
      commit("pushMasks", tempArr);
    },
    generateTouchPoints({ commit, rootState }, aspectRatio) {
      let tempArr = [];
      for (let animation of rootState.macroAnimations) {
        if (process.env.VUE_APP_IS_BROWSER === "false") {
          for (let touchPoint of animation.touchPoints[aspectRatio]) {
            let tempObj = {
              ref: touchPoint.ref,
              position: touchPoint.touchPointPosition,
              size: touchPoint.touchPointSize,
              highlight: animation.highlight
            };
            tempArr.push(tempObj);
          }
        } else {
          for (let touchPoint of animation.touchPoints) {
            let tempObj = {
              ref: touchPoint.ref,
              position: touchPoint.touchPointPosition,
              size: touchPoint.touchPointSize,
              highlight: animation.highlight
            };
            tempArr.push(tempObj);
          }
        }
      }
      commit("pushTouchpoints", tempArr);
    },

    microAnimationButtonGenerator({ commit, rootState }) {
      let tempArr = [];
      for (let animation of rootState.microAnimations) {
        tempArr.push({
          ref: animation.ref,
          position: animation.buttonPosition,
          id: animation.buttonId,
          delay: animation.buttonDelay,
          text: animation.text
        });
      }
      commit("pushMicroAnimationBUttons", tempArr);
    }
  }
};
